import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import enLang from "./locales/en/en.json";
import frLang from "./locales/fr/fr.json";

const resources = {
  FR: {
    translation: frLang,
  },
  EN: {
    translation: enLang,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "FR",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
